// biome-ignore lint/style/noRestrictedImports: encapsulation
import { isError as isError_ } from "remeda";

export const isError: <T>(error: T | Error) => error is Error = isError_;
